import { icons } from 'lucide-react'
import React from 'react'

type IconProps = {
  name: string
  color?: string
  size?: number
  className?: string
}

export const Icon = ({ name, color, size = 20, className, ...props }: IconProps) => {
  const LucideIcon = (icons as any)[name] as React.ComponentType<any> | undefined

  if (!LucideIcon) {
    return <svg width={size} height={size} className={className} {...props} />
  }

  return <LucideIcon color={color} size={size} className={className} {...props} />
}

export default Icon
